import { render, staticRenderFns } from "./Next.vue?vue&type=template&id=705fa0d6&scoped=true"
import script from "./Next.vue?vue&type=script&lang=js"
export * from "./Next.vue?vue&type=script&lang=js"
import style0 from "./Next.vue?vue&type=style&index=0&id=705fa0d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705fa0d6",
  null
  
)

export default component.exports